<style scoped>
  @import './otp-input-authentication.scss';
</style>

<script>
import Continue from '../lightbox/continue/continue.vue'
import { CONSTANT, AUTH_METHODS } from '@/utils/constant.js'
import { EventBus } from '@/event-bus.js'
import sharedService from '@/utils/shared-service'
import { BPopover } from 'bootstrap-vue'
import requestBody from '@/orchestration/authSDK/request-parameter'
import traceService from '../shared/trace/trace-service'
import { mapGetters } from 'vuex'
import toasterService from '../../utils/toaster'
import { MFA_METHODS, MFA_API_METHODS, FIDO_METHODS } from '../../utils/constant'

export default {
  name: 'OtpInputAuthentication',

  components: {
    Continue,
    BPopover
  },
  props: {
    initiateAuthParams: {
      type: Object
    }
  },

  data () {
    return {
      otp: [],
      otpLengthErr: false,
      error: '',
      successMsg: '',
      valueParts: _fill([], '', CONSTANT.CODE_LENGTH),
      limitExceedError: false,
      authMethod: {},
      initiateAuthResponse: '',
      authUIResponse: {},
      sessionAssuranceValue: null,
      mfaMethodInstanceId: ''
    }
  },

  computed: {
    ...mapGetters(['isNTSFlowEnabled', 'merchantSavedCards', 'enrollMaskCard', 'srcNetwork', 'consumerInfo', 'consumerJwt'])
  },

  watch: {
    valueParts () {
      this.emitOtpInput()
    }
  },

  created () {
    this.authMethod = this.initiateAuthParams.request.authenticateRequest.authenticationMethod
    this.$store.commit('lightBoxloaderOn', false)
    this.resetOtpBoxes()
  },

  mounted () {
    EventBus.$on('handleError', (event) => {
      this.$store.commit('lightBoxloaderOn', false)
      this.error = event
      this.resetOtpBoxes()
    })
    EventBus.$on('handleSuccess', (event) => {
      this.$store.commit('lightBoxloaderOn', false)
      this.successMsg = event
      setTimeout(() => {
        this.successMsg = false
      }, 2000)
      this.resetOtpBoxes()
    })
    EventBus.$on('authUIResponse', this.handlerAuthUIResponse)
  },

  beforeDestroy () {
    EventBus.$off('authUIResponse', this.handlerAuthUIResponse)
  },

  methods: {
    handlerAuthUIResponse (event) {
      if (event?.from === 'addCard' && event?.type === 'Error') {
        this.$store.dispatch('lightBoxloaderOn', false)
        clearInterval(sharedService.authUIPopupCloseTimer)
        toasterService.onFailure('Popup window is closed unexpected')
        this.savecard()
      } else {
        this.$store.dispatch('lightBoxloaderOn', false)
        this.processAuthUiResponse(event)
      }
    },

    async savecard () {
      await this.saveCardDetail()
    },

    async processAuthUiResponse (response) {
      console.log('Auth UI Response ', response)
      if (response === 'REGISTRATION_SUCCESS') {
        await this.performBindForNativeFlow(this.sessionAssuranceValue)
      } else if (response === 'AUTHENTICATOR_ALREADY_EXISTS') {
        toasterService.onFailure(`Card is already bound to the passkey`)
        await this.saveCardDetail()
      } else {
        toasterService.onFailure(`User declined FIDO or binding process failed`)
        await this.saveCardDetail()
      }
    },

    async completeAuthenticate () {
      const network = 'mastercard'
      const request = this.initiateAuthParams.request.authenticateRequest
      const response = this.initiateAuthParams.response.authenticateResponse
      const srcDigitalCardId = request.accountReference.srcDigitalCardId
      const { authenticationMethod, srcCorrelationId, serviceId } = request
      const authenticationSessionId = response.authenticationSessionId
      const otpValue = this.otp
      let reqParams = requestBody[AUTH_METHODS.B2B_COMPLETE_AUTHENTICATE](
        authenticationMethod,
        authenticationSessionId,
        srcCorrelationId,
        srcDigitalCardId,
        serviceId,
        otpValue
      )
      try {
        let response = await sharedService.getB2BAuthenticateApiResponse(reqParams)
        traceService.updateCallTraces(network, response.callTraces, true)
        this.$store.commit('setMdesAuthenticateResponse', response)
        return true
      } catch (err) {
        let errorLog = err.response.data.callTraces
        traceService.updateCallTraces(network, errorLog, false)
        this.error = err.response.data.message
        EventBus.$emit('handleError', this.error)
        return false
      }
    },

    /**
     * join all values of otp boxes and store in otp
     */
    emitOtpInput () {
      this.otp = this.valueParts.join('').slice(0, CONSTANT.CODE_LENGTH)
    },

    /**
     * Resetting input boxes of OTP to empty
     */
    resetOtpBoxes () {
      this.otp = ''
      this.valueParts = _fill([], '', CONSTANT.CODE_LENGTH)
      this.$store.commit('lightBoxloaderOn', false)
    },

    /**
     * focusing input box by index number
     * @param index
     */
    focus (index) {
      const inp = this.$refs.wrap.children[index]
      if (inp) {
        inp.focus()
      }
    },

    /* eslint complexity: ["error", 14] */
    /**
     * Handle event of keydown
     * @param event
     * @param index
     */
    handleKeyDown (event, index) {
      const key = _sanitizeEventKey(event.key)
      if (event.key === 'Enter') {
        this.$emit('enter')
        event.stopPropagation()
      }
      if (!key) {
        return false
      } else if (key === 'Backspace') {
        if (this.valueParts[index]) {
          return (this.valueParts[index] = '')
        }
        this.focus(index - 1)
      } else if (
        !event.shiftKey &&
        (key === 'ArrowRight' || key === 'Right')
      ) {
        this.focus(index + 1)
      } else if (
        !event.shiftKey &&
        (key === 'ArrowLeft' || key === 'Left')
      ) {
        this.focus(index - 1)
      } else if (key.length === 1 && this.valueParts[index]) {
        this.valueParts[index] = key
        this.$forceUpdate()
        this.focus(index + 1)
        this.emitOtpInput()
      }
    },

    /**
     * handle event of input
     * @param event
     * @param index
     */
    handleInput (event, index) {
      const value = this.valueParts[index]
      if (value) {
        if (value.length > 1) {
          this.valueParts[index] = value[value.length - 1]
        }
        this.focus(index + 1)
      }
    },

    /**
     * Call B2B_NTS_AUTHENTICATE_REGISTER to execute NTS flow
     */
    async executeNativeFlow () {
      const network = 'mastercard'
      const request = this.initiateAuthParams.request.authenticateRequest
      const srcDigitalCardId = request.accountReference.srcDigitalCardId
      const { srcCorrelationId, serviceId } = request
      this.$store.commit('loaderOn', true)
      let reqParams = requestBody[AUTH_METHODS.B2B_NTS_AUTHENTICATE_REGISTER](
        srcCorrelationId,
        srcDigitalCardId,
        serviceId
      )
      try {
        let response = await sharedService.getB2BAuthenticateApiResponse(reqParams)
        traceService.updateCallTraces(network, response.callTraces, true)
        this.$store.commit('loaderOn', false)
        return response
      } catch (err) {
        this.$store.commit('loaderOn', false)
        let errorLog = err.response.data.callTraces
        traceService.updateCallTraces(network, errorLog, false)
        toasterService.onFailure(err.response.data.message)
        this.error = err.response.data.message
        return false
      }
    },

    /**
     * Perform Bind for Native flow
     * @param sessionAssuranceValue
     */
    async performBindForNativeFlow (sessionAssuranceValue) {
      try {
        this.$store.commit('loaderOn', true)
        this.error = ''
        this.$store.commit('setConsumerContactInfo', '')

        let maskedCardData = this.enrollMaskCard.serviceId ? this.enrollMaskCard : this.selectedSavedCardDetails.maskedCard
        let response = await sharedService.getBindMfaApiResponse(requestBody[MFA_METHODS.BINDNTS](maskedCardData, sessionAssuranceValue), MFA_API_METHODS.BIND)
        traceService.updateCallTraces(this.srcNetwork, response.callTraces, true)
        toasterService.onSuccess(this.$t('successMessages.BIND_NTS_SUCCESS'))
        if (response) {
          this.mfaMethodInstanceId = response.mfaMethodInstanceId
          await this.saveCardDetail()
        }
        this.$store.commit('loaderOn', false)
      } catch (err) {
        this.$store.commit('loaderOn', false)
        let errorLog = err.response.data.callTraces
        traceService.updateCallTraces(this.srcNetwork, errorLog, true)
        toasterService.onFailure('BIND_FAILED')
        await this.saveCardDetail()
      }
    },

    async saveCardDetail () {
      try {
        let saveCardResponse = await sharedService.getScofPayloadApiResponse(requestBody[FIDO_METHODS.SAVE_CARD](this.consumerJwt, this.enrollMaskCard, this.mfaMethodInstanceId))
        if (saveCardResponse) {
          const merchantCardIds = this.consumerInfo.merchantCardIds
          if (merchantCardIds === null) {
            this.consumerInfo.merchantCardIds = []
          }
          const cardDetails = {
            srcEnvironment: this.$store.getters.environment,
            region: this.$store.getters.region,
            scofMaskedCard: this.enrollMaskCard,
            cardbrand: 'MASTERCARD',
            srcDpaId: this.scofDpaId,
            bindingIds: null,
            srcCorrelationId: this.enrollMaskCard.srcCorrelationId
          }
          this.consumerInfo.merchantCardIds.push(cardDetails)
          this.$store.commit('changeConsumerInfo', this.consumerInfo)
          EventBus.$emit('cardSaved', true)
        }
      } catch (err) {
        this.error = this.$t('SAVE_CARD_ERROR')
      }
    },

    /**
     * This method validate the otp
     * @param otp
     * @returns {Promise<void>}
     */
    async completeIdValidation () {
      this.$store.commit('lightBoxloaderOn', true)
      let response = await this.completeAuthenticate()
      this.$store.commit('lightBoxloaderOn', false)
      if (response) {
        if (this.isNTSFlowEnabled && sharedService.checkFeatureFlag('START_NTS_CHANGES') && this.$store.getters.enableNativeIntegrationFlow) {
          let authResponse = await this.executeNativeFlow()
          if (authResponse) {
            this.sessionAssuranceValue = authResponse.authenticateResponse.sessionAssuranceValue
            const authURl = authResponse.authenticateResponse.methodAttributes.uriData.uri
            sharedService.openAuthUI(authURl, this.sessionAssuranceValue, 'addCard')
          } else {
            await this.saveCardDetail()
          }
          return
        }
        this.$store.commit('setConsumerContactInfo', '')
        this.$router.push('/authreview').catch(err => { console.error(err) })
      }
    },

    /**
     * recall on click of resend code
     */
    async resendOtp () {
      this.$emit('countinueWithAnotherWay')
    },

    /**
     * This method submits the otp
     * @param otp
     */
    submitForm () {
      this.error = ''
      this.emitOtpInput()
      this.otpLengthErr = this.otp.length < CONSTANT.CODE_LENGTH
      if (this.otpLengthErr) {
        return false
      } else {
        this.completeIdValidation()
      }
    }
  }
}

function _fill (arr, val, l) {
  arr.length = l
  arr.fill(val, 0, l)
  return arr
}

function _sanitizeEventKey (key) {
  return key === 'Unidentified' ? undefined : key
}
</script>

<template>
  <div>
    <div
      v-if="error"
      class="alert alert-danger"
    >
      {{ error }}
    </div>
    <div
      v-if="successMsg"
      class="alert alert-success"
    >
      {{ $t ('successMessages.' + successMsg) }}
    </div>
    <h4 class="text-center mt-4 font-weight-bold">
      {{ $t ('label.otpInputLabel') }}
    </h4>
    <br>
    <h5 class="text-center mt-2 mb-3">
      {{ $t ('label.enterOtp') }}
      {{ $t ('label.sentTo') }}
      <div>{{ authMethod.authenticationCredentialReference }}</div>
    </h5>
    <div
      ref="wrap"
      class="align-center mt-4"
    >
      <template v-for="(char, index) in valueParts">
        <input
          :key="index"
          v-model="valueParts[index]"
          :autofocus="index === 0"
          v-bind="$attrs"
          type="text"
          onkeypress="if(this.value.length===1) return false;"
          class="otp-input form-control d-inline"
          minlength="1"
          maxlength="1"
          inputmode="numeric"
          @keydown="handleKeyDown($event, index)"
          @input="handleInput($event, index)"
        >
      </template>
    </div>
    <p
      v-if="otpLengthErr"
      id="otpHelpBlock"
      class="form-text text-center text-danger"
    >
      {{ $t ('errorMessages.invalidOtp') }}
    </p>
    <p
      v-if="limitExceedError"
      id="limitExceedError"
      class="form-text text-center text-danger"
    >
      {{ $t ('errorMessages.RETRIES_EXCEEDED') }}
    </p>
    <p class="text-center mt-1">
      <span
        id="continue-another-way"
        class="btn-footer"
        @click="resendOtp"
      >
        {{ $t ('label.continueAnotherWay') }}
      </span>
    </p>
    <continue
      @submit="submitForm()"
    />
  </div>
</template>
